import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';

const RatingChart = ({ ratings, onClick }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (ratings) {
      const data = {
        labels: ratings.map(rating => rating.label),
        datasets: [
          {
            label: 'Ratings',
            backgroundColor: 'rgb(75,192,192)',
            borderColor: 'rgb(75,192,192)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgb(75,192,192)',
            hoverBorderColor: 'rgb(75,192,192)',
            data: ratings.map(rating => rating.value)
          }
        ]
      };
      setChartData(data);
    }
  }, [ratings]);

  return (
    <div style={{ fontFamily: "Noto Sans", }}>
      {chartData && (
        <Bar
          onClick={onClick}
          data={chartData}
          width={250}
          height={262}
          options={{
            maintainAspectRatio: false,
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  stepSize: 1, // Set the step size to 1
                  min: 1, // Set the minimum value to 1
                  max: 5, // Set the maximum value to 5
                }
              }]
            }
          }}
        />
      )}
    </div>
  );
};

export default RatingChart;